// actions.js

import axios from 'axios';


export default {
    async fetchBrandList(ctx){
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/brands`, config);
            ctx.commit('updateBrandList', response.data) ;
        } catch (error) {
            return error;
        }
    },
};
